module.exports = __webpack_public_path__ + "static/ExtendIT-Slider2-b337901177b20ebe9a9fc4818a5bd7df.jpg";